// extracted by mini-css-extract-plugin
module.exports = {"image":"ProductDetail_image__aZMw4","add_cart":"ProductDetail_add_cart__QJMJR"};